import { Router } from 'react-router'
import { ApolloProvider } from 'react-apollo'
import {
  history,
  withContainer,
  withHooks,
  BreadcrumbsContext,
  LocalSettingsContext,
  NotificationsContext,
  ModalContext,
  useQueryParamsSubscriptions,
  compose,
} from 'labguard-cdk'
import { client } from 'src/services/apollo'
import { useIntl } from 'react-intl'
import MouseBackend from 'react-dnd-mouse-backend'
import { DndProvider } from 'react-dnd'
import { NowContext, AccountContext } from 'src/contexts'
import Main from './Main'
import { AccountI18n } from './common'

/**
 * HOC that inserts intl and the notify API in the client cache in order to be used within apollo links
 * (because `cache` is by default in the operation context available in the links)
 */
const withEnhancedApolloCache = withHooks(() => {
  client.cache.intl = useIntl()
  client.cache.notify = NotificationsContext.use()
})

export default compose(
  // provide drag'n'drop
  withContainer(DndProvider, () => ({ backend: MouseBackend })),

  // provide Router
  withContainer(Router, () => ({ history })),

  // provide apollo (graphql)
  withContainer(ApolloProvider, () => ({ client })),

  // provide account context
  AccountContext.withProvider(),

  // provide i18n translations
  withContainer(AccountI18n),

  // provide notifications
  NotificationsContext.withProvider(),

  // provide current date
  NowContext.withProvider(),

  // provide current breadcrumb
  BreadcrumbsContext.withProvider(),

  // provide synchronization with settings in local storage
  LocalSettingsContext.withProvider(),

  // enhance the apollo cache with some of the data from the above providers
  withEnhancedApolloCache,

  // provide modals
  ModalContext.withProvider(),

  // initialize subscriptions
  withHooks(useQueryParamsSubscriptions)
)(Main)
